export const SIGNUP_REF_ACTION = 'signup_ref_action';
export const FAVORITE_BUTTON = 'favorite_button';

export const SIGNUP_REF_ACTION_TYPES = {
  FAVORITE_BUTTON: 'favorite_button'
};
